
import { ProvVisCreator } from '@visdesignlab/trrack-vis';
import { ProvenanceEventTypes, State } from '@/types';
import {
  computed, ComputedRef, defineComponent, onMounted,
} from '@vue/composition-api';
import store from '@/store';
import { Provenance } from '@visdesignlab/trrack';

export default defineComponent({
  setup() {
    const provenance: ComputedRef<Provenance<State, ProvenanceEventTypes, unknown> | null> = computed(
      () => store.state.provenance,
    );

    onMounted(() => {
      const provDiv = document.getElementById('provDiv');
      if (provenance.value !== null && provDiv != null) {
        ProvVisCreator(
          provDiv,
          provenance.value,
          (newNode: string) => store.commit.goToProvenanceNode(newNode),
          true,
          true,
          provenance.value.root.id,
        );
      }
    });

    function toggleProvVis() {
      store.commit.toggleShowProvenanceVis();
    }

    return { toggleProvVis };
  },
});
